import { ErrorHandler, Injectable } from '@angular/core';
import { LoggerService } from '@app/services/utils/logger.service';
import { createErrorHandler } from '@sentry/angular';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private sentryHandler = createErrorHandler({ showDialog: false });
  handleError(error: unknown): void {
    // Chunk-load failures are handled (reload prompt) and must not be reported — deploy churn, not a bug.
    if (customErrorHandlerForChunkFailed(error)) {
      return;
    }
    LoggerService.error(error);
    this.sentryHandler.handleError(error);
  }
}

export const customErrorHandlerForChunkFailed = (error: unknown): boolean => {
  const chunkFailedMessage = /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Loading chunk [\d]+ failed/i;
  if (chunkFailedMessage.test((error as Error)?.message)) {
    if (typeof window !== 'undefined' && confirm('A new version is available! Would you like to load it now?')) {
      window.location.reload();
    }
    return true;
  }
  return false;
}
